module.exports = __webpack_public_path__ + "assets/chart__clock.c62abb5e.svg";